<!-- search.component.html -->
<form [formGroup]="searchForm" (ngSubmit)="onSearch()">
    <div class="d-flex">
    <div class="ml-2">
    <label for="selectedFilter">Select Filter:</label>
    <select id="selectedFilter" formControlName="selectedFilter" class="form-control">
        <option *ngFor="let option of filterOptions" [value]="option.name">{{ option.value }}</option>
    </select>
    </div>
    <div class="ml-2">
    <label for="filterValue">Filter Value:</label>
    <input type="text" *ngIf="!this.selectedFilter?.values" id="filterValue" formControlName="filterValue" class="form-control">
    <select *ngIf="this.selectedFilter?.values" formControlName="filterValue" class="form-control">
        <option *ngFor="let option of this.selectedFilter?.values | keyvalue" [value]="option.key">{{ option.value }}</option>
    </select>
    </div>
  <div class="ml-2 add-filter">
    <button class="btn btn-primary p-2" type="submit">Add Filter</button>
  </div>
    </div>
</form>

<div *ngFor="let filter of appliedFilters; let i = index">
    <ng-container *ngIf="filter.values; else stringFilter">
        {{ filter.name }}: {{ filter.values[filter.value] }}
    </ng-container>

    <ng-template #stringFilter>
        {{ filter.name }}: {{ filter.value }}
    </ng-template>
    <button class="btn" (click)="removeFilter(i)">Remove</button>
</div>
